import '../styles/SettingsActionStrip.css';
import React from 'react';

function SettingsActionStrip() {
  return (
    <section className="sas-root" aria-label="Settings storage and return">
      <div className="sas-ray" data-content-rail="primary">
        <div className="sas-slug">
          <span className="sas-slug__mark" aria-hidden="true" />
          <div className="sas-slug__text">
            <span className="sas-slug__label">Stored on this machine</span>
            <p className="sas-slug__line">
              Your configuration is stored locally on this machine. <strong>No cloud required</strong>.
            </p>
          </div>
        </div>

        <a className="sas-route" href="/dashboard">
          Return to Dashboard
          <span className="sas-route__arrow" aria-hidden="true">&#8594;</span>
        </a>
      </div>
    </section>
  );
}

export default SettingsActionStrip;